/**
 * Utility functions used to help run the CollaboratorsManager
 *
 * Copyright (c) 2019 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
import { isBoardOwner } from 'client/app/js/utils/accessInterpreter/board'
const EMAIL_REGEX = /[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/

/**
 * Returns a boolean that indicates whether the provided input string is an email
 * @param {String} input The input string
 */
export const isEmail = (input) => EMAIL_REGEX.test(input)

/**
 * Convert collaborators to a format that is compatible with UserFollowsList
 * Removes the owner collaborator from the result
 * @param {Object} board The current board in which to extract the collaborators
 */
export const getCollaborators = (board) => {
  const collaboratorsProfileData = {}
  const collaboratorsOrder = []
  const invites = []
  let owner = null

  // Assume no collaborators if board data does not contain collaborators array
  const collaboratorsArray = board.collaborators ?? [board.owner]

  collaboratorsArray.forEach((collaborator) => {
    if (isBoardOwner(collaborator, board)) {
      owner = collaborator
    } else if (collaborator.uid) {
      const uid = collaborator.uid

      collaboratorsOrder.push(uid)
      collaboratorsProfileData[uid] = collaborator
    } else if (collaborator.type === 'INVITED_TO' && collaborator.email) {
      invites.push(collaborator)
    }
  })

  return {
    owner,
    collaborators: collaboratorsProfileData,
    order: collaboratorsOrder,
    invites
  }
}
